import * as React from "react";

type ComparisonBadgeProps = {
  actual: number;
  predicted: number;
};

export const ComparisonBadge: React.FC<ComparisonBadgeProps> = ({ actual, predicted }) => {
  const isPositive = actual >= predicted;
  const isZero = predicted === 0;
  const bgColorClass = isZero ? "" : isPositive ? "bg-emerald-700 text-white" : "bg-rose-700 text-white";

  return (
    <div
      className={`${bgColorClass} mx-auto flex h-5 w-5 items-center justify-center rounded-full text-xs leading-none`}
    >
      <span>{actual}</span>
    </div>
  );
};
